export default function srcset (imageSrcset) {
  const keys = Object.keys(imageSrcset.sizes).filter(key => !/width|height/.test(key))

  return keys.map((key) => {
    return `${imageSrcset.sizes[key]} ${imageSrcset.sizes[key + '-width']}w`
  }).join(',')
}
